<template>
  <div class="project-card bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300">
    <a :href="project.link" target="_blank" class="block">
      <div class="relative h-48 overflow-hidden">
        <img :src="project.image" :alt="project.title" class="w-full h-full object-cover">
      </div>
      <div class="p-4">
        <h3 class="text-xl font-semibold mb-2 text-black dark:text-white">{{ project.title }}</h3>
        <p class="text-gray-700 dark:text-gray-300 description">{{ project.description }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.description {
  white-space: pre-line;
}
</style>